import React from "react";
import { ASSETS } from "@/lib/assets";
import { CcHeader } from "./CcHeader";
import { KpiStrip } from "./KpiStrip";
import { UsagePanel, ResolutionPanel, TopicsPanel } from "./TechPanels";
import { PipelinePanel, ValueTrendPanel, FailuresPanel } from "./WarrantyPanels";
import { AiPanel } from "./AiPanel";
import { HealthPanel, InsightsPanel, RecentPanel } from "./SidePanels";
import { SupportPanel } from "./SupportPanel";

// The full 1920x1080 board. mode: "admin" (clickable, with actions) or "display" (TV, view only).
export function CommandCentre({ data, stale, mode = "admin", actions }) {
  const interactive = mode === "admin";
  return (
    <div data-testid="command-centre" data-mode={mode} className="relative w-[1920px] h-[1080px] overflow-hidden bg-[#050505] text-neutral-100 font-body">
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-[0.03] grayscale" style={{ backgroundImage: `url("${ASSETS.adminBackdrop}")` }} />
      <div aria-hidden className="pointer-events-none absolute -top-40 -left-40 w-[700px] h-[500px] rounded-full bg-[#73bf44]/[0.05] blur-3xl" />
      <div className="relative h-full p-4 flex flex-col gap-3">
        <CcHeader data={data} stale={stale} mode={mode} actions={actions} />
        <KpiStrip data={data} />
        <div className="flex-1 min-h-0 grid grid-cols-12 gap-3">
          <div className="col-span-4 flex flex-col gap-3 min-h-0" data-testid="cc-column-tech">
            <UsagePanel tech={data.tech} interactive={interactive} />
            <ResolutionPanel tech={data.tech} />
            <TopicsPanel tech={data.tech} />
          </div>
          <div className="col-span-5 flex flex-col gap-3 min-h-0" data-testid="cc-column-warranty">
            <PipelinePanel war={data.warranty} />
            <div className="h-[318px] shrink-0 grid grid-cols-2 gap-3">
              <ValueTrendPanel war={data.warranty} />
              <FailuresPanel war={data.warranty} />
            </div>
            <AiPanel ai={data.ai} />
          </div>
          <div className="col-span-3 flex flex-col gap-3 min-h-0" data-testid="cc-column-side">
            <HealthPanel health={data.health} />
            <InsightsPanel insights={data.insights} />
            <SupportPanel tickets={data.tech.tickets} />
            <RecentPanel recent={data.tech.recent} interactive={interactive} />
          </div>
        </div>
      </div>
    </div>
  );
}
